module.exports = require('./helpers/bundle-url').getBundleURL('04OEz') + "logo.c51670a8.svg";